import { Button } from "@mui/material"
import { IfTooltip } from "lib/if-tooltip"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { DraftStatus } from "authoring/lib/enum/draft-status.mjs"
import { useParams } from "react-router"
import { rejectDraftReview } from "../../controller/reject-draft-review"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { navigateProject } from "authoring/routes/project/utilities/project-navigation"
import { useDialog } from "lib/@hooks/useDialog"
import { RejectReviewDialog } from "./reject-review-dialog"

export function RejectReviewButton() {
    const { target, goToNext } = useBoundContext()
    const { projectId, scheduleId } = useParams()
    const { status } = target
    const rejectReviewDialog = useDialog(<RejectReviewDialog />)

    const disabled = status !== DraftStatus.SUBMITTED

    let disabledMessage = ""
    if (status === DraftStatus.APPROVED) {
        disabledMessage = "Review was already approved"
    } else if (status === DraftStatus.REJECTED) {
        disabledMessage = "Review was already rejected"
    } else if (disabled) {
        disabledMessage = "Only submitted drafts can be rejected"
    }

    return (
        <IfTooltip condition={disabled} title={disabledMessage}>
            <Button
                size="small"
                variant="contained"
                color="error"
                disabled={disabled}
                onClick={handleRejectReview}
                data-cy="reject-review-button"
            >
                Reject
            </Button>
        </IfTooltip>
    )

    async function handleRejectReview() {
        try {
            const dialogResult = await rejectReviewDialog()
            if (dialogResult) {
                const rejected = await rejectDraftReview({
                    projectId,
                    scheduleId,
                    rejectionSummary: dialogResult.rejectionSummary,
                })
                if (rejected) {
                    successSnackbar("Review rejected successfully")
                    if (goToNext) {
                        await goToNext("rejected")
                    } else {
                        navigateProject(projectId)
                    }
                } else {
                    errorSnackbar("Failed to reject review")
                }
            }
        } catch (error) {
            errorSnackbar(error?.message ?? "Failed to reject review")
        }
    }
}
